import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import { deleteRoute, getRoutes } from '../../../../services/taxonomies/routes';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import Column from '../../../../helpers/columns';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const RoutesList = () => {
  const { t } = useTranslation();
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const { pagination, content, handleChange, reload } =
    useDatasource(getRoutes);

  const columns = useMemo(
    () => [
      Column.text('code', t('entity.taxonomy.route.code'), { filter: true }),
      Column.text('name', t('entity.taxonomy.route.name'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.route.deleted._'), {
        width: 150,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.route.deleted.true'),
          t('entity.taxonomy.route.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/taxonomies/routes/${record.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/taxonomies/routes/${record.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.route._delete', record)}
              message={t('entity.taxonomy.route._deleted', record)}
              item={record}
              action={deleteRoute}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.route._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.taxonomy.route._singular')}
            path="/admin/taxonomies/routes/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="name"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default RoutesList;
